module.exports = "<ion-nav-view></ion-nav-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/app/index.tpl.html
// module id = 180
// module chunks = 0